import { useEffect } from "react";

import useCurrentPageDetails from "./useCurrentPageDetails";

const useDocumentHeadUpdates = () => {
  const currentRouteDetails = useCurrentPageDetails();

  useEffect(() => {
    document.title = `Assets View - ${currentRouteDetails.name || "Admin Panel"}`;
  }, [currentRouteDetails.name]);
};

export default useDocumentHeadUpdates;
